<template>
  <auth-layout>
    <div>
      <h3 class="fw-bold text-uppercase mb-2">Registro</h3>
      <p class="mb-4">
        Ingresa tu número de empleado y crea una contraseña para tu cuenta.
      </p>
    </div>

    <div
      class="alert alert-danger"
      role="alert"
      v-if="hasError"
    >
      {{ msg }}.
    </div>

    <form @submit.prevent="RegisterPerson">
      <!-- Username Input -->
      <username-input
        id="username"
        name="username"
        autocomplete="username"
        v-model="form.employee_code"                
        placeholder="No Empleado"
        :class="{ 'is-invalid': hasError }"
      />

      <!-- Password Input -->
      <password-input
        id="current-password"
        name="current-password"
        autocomplete="current-password"
        v-model="form.password"
        :class="{ 'is-invalid': hasError }"                
      />

      <!-- Password Confirmation Input -->
      <password-input
        id="confirm-password"
        name="confirm-password"
        placeholder="Confirmar Contraseña"
        autocomplete="confirm-password"
        v-model="form.password_confirmation"
        :class="{ 'is-invalid': hasError }"                
      />

      <button
        type="submit"
        class="btn btn-portal btn-lg w-100 text-uppercase mt-3"
      >
        Registrar
      </button>

      <div class="mt-3 text-center">
        ¿Ya tienes una cuenta?
        <router-link :to="{ name: 'SignIn' }" class="buzonColor">
          Inicia sesión aquí
        </router-link>
      </div>
    </form>
  </auth-layout>
</template>

<script>
import axios from "axios";
import UsernameInput from './components/UsernameInput.vue';
import PasswordInput from './components/PasswordInput.vue';
import AuthLayout from "@/template/AuthLayout.vue";
export default {
  name: "Register",
  components: {
    UsernameInput,
    PasswordInput,
    AuthLayout,
  },
  data() {
    return {
      hasError: false,
      msg: null,
      form: {
        employee_code: "",
        password: "",
        password_confirmation: "",
      },
    };
  },
  methods: {
    RegisterPerson() {
      axios
        .post("registerPerson", this.form)
        .then((response) => {
          //console.log(response.data.errors);
          if (response.data.errors) {
            this.msg = response.data.errors;
            this.hasError = true;
            setTimeout(() => {
              this.hasError = false;
            }, 5000);
            this.form.password = null;
            this.form.password_confirmation = null;
          } else if (response.data.email_error) {
            this.msg = response.data.email_error;
            this.hasError = true;
            setTimeout(() => {
              this.hasError = false;
            }, 7000);
          } else if (response.data.employee_code_error) {
            this.msg = response.data.employee_code_error;
            this.hasError = true;
            setTimeout(() => {
              this.hasError = false;
            }, 7000);
          } else {
            console.log(response.data);
            this.$swal({
              title: response.data,
              icon: "success",
            });
            this.$router.replace({
              name: "SignIn",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.msg = "Código de empleado erróneo.";
          this.hasError = true;
          setTimeout(() => {
            this.hasError = false;
          }, 5000);
          this.form.password = null;
          this.form.password_confirmation = null;
        });
    },
  },
};
</script>

<style scoped></style>
